<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add Agency Member
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.agency_name"
                disabled
                outlined
                label="Agency Name"
                prepend-inner-icon="mdi-domain"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.agency_id"
                disabled
                outlined
                label="Agency ID"
                prepend-inner-icon="mdi-domain"
              ></v-text-field>
            </v-col>

            <v-col sm="6">
              <v-text-field
                v-model="form.user_id"
                outlined
                label="User ID"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>

            <!-- <v-col sm="6">
              <v-text-field
                v-model="form.performance_score"
                outlined
                label="Performance Score"
                type="number"
                prepend-inner-icon="mdi-star"
              ></v-text-field>
            </v-col>

            <v-col sm="6">
              <v-text-field
                v-model="form.rewards_given"
                outlined
                label="Rewards Given (₹)"
                type="number"
                prepend-inner-icon="mdi-currency-inr"
              ></v-text-field>
            </v-col> -->
          </v-row>

          <v-divider class="my-5"> </v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Member
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "AgencyMemberCreatePage",
  data() {
    return {
      filter: {
        search_keyword: "",
      },
      form: {
        agency_name: "",
        agency_id: "",
        user_id: "",
      },
      agencies: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      console.log("this.$route.query", this.$route);

      if (this.$route.params.agencyId) {
        this.filter.agency_id = this.decryptIt(this.$route.params.agencyId);
      } else {
        this.filter.agency_id = "";
      }

      console.log("this.filter.agency_id", this.filter.agency_id);

      // this.filter.search_keyword = this.filter.search_keyword
      //   ? this.filter.search_keyword
      //   : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&agency_id=" +
        this.filter.agency_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`agencies?${query}`)
        .then((response) => {
          this.agencies = response.data.data[0];
          console.log("agencies", this.agencies);
          this.form.agency_id = this.agencies.agency_code;
          this.form.agency_name = this.agencies.name ?? this.agencies.owner?.first_name;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.agency_id = this.agencies.id;
        let response = await axios.post("/agency_members", this.form);
        console.log("response", response);

        this.isLoading = false;
        this.$router.back();
      } catch (error) {
        console.error("Error saving member:", error);
        this.isLoading = false;
      }
    },
  },
};
</script>
